import React from 'react';
import { useLanguage } from './LanguageContext';
import './LanguageSwitcher.css'; // Подключаем наши новые, унифицированные стили

const LanguageSwitcher = () => {
    // Берем language и switchLanguage из контекста, как и раньше
    const { language, switchLanguage }= useLanguage();

    return (
        <div className="language-switcher">
            {/* === ВОТ, СУКА, КОД, СПИЗЖЕННЫЙ С ТВОЕЙ МОБИЛКИ === */}
            <div className="language-toggle-container">
                <button
                    // Кнопка для русского языка
                    className={`lang-btn ${language === 'ru' ? 'active' : ''}`}
                    onClick={() => switchLanguage('ru')}
                >
                    Рус
                </button>
                <button
                    // Кнопка для казахского языка
                    className={`lang-btn ${language === 'kz' ? 'active' : ''}`}
                    onClick={() => switchLanguage('kz')}
                >
                    Қаз
                </button>
                {/* 
                  Этот div - это и есть наш ползунок.
                  Мы двигаем его с помощью CSS, добавляя класс 'slide-right', когда активен 'kz'.
                */}
                <div className={`language-slider ${language === 'kz' ? 'slide-right' : ''}`}></div>
            </div>
            {/* ======================================================= */}
        </div>
    );
};

export default LanguageSwitcher;